// Domain layer shared by src/ and functions/.
//
// Scaffolding only — nothing imports this yet. It exists so future phases
// (replacing string-literal collection names, ad hoc status strings, and
// bare `new Error(...)` calls in src/ and functions/) have a single place
// to land.

const { COLLECTIONS } = require('./src/collections');
const entities = require('./src/entities');
const status = require('./src/status');
const ids = require('./src/ids');
const errors = require('./src/errors');
const validation = require('./src/validation/schemas');
const utils = require('./src/utils/chunk');

module.exports = {
  COLLECTIONS,
  ...entities,
  ...status,
  ...ids,
  ...errors,
  ...validation,
  ...utils,
};
